export enum TaskCode {
  REVIEW_REFERRAL_SLIP = 'REVIEW_REFERRAL_SLIP',
  FILL_OUT_INTAKE_CALL_SHEET = 'FILL_OUT_INTAKE_CALL_SHEET',
  CONFIRM_PROCEDURE_AND_PROVIDE_FIRST_AVAILABLE_APPOINTMENT = 'CONFIRM_PROCEDURE_AND_PROVIDE_FIRST_AVAILABLE_APPOINTMENT',
  REVIEW_SCHEDULE_FOR_ADDITIONAL_APPOINTMENT_TIMES = 'REVIEW_SCHEDULE_FOR_ADDITIONAL_APPOINTMENT_TIMES',
  NOTIFY_REFERRING_DENTAL_OFFICE_UNABLE_TO_SCHEDULE = 'NOTIFY_REFERRING_DENTAL_OFFICE_UNABLE_TO_SCHEDULE',
  UPDATE_PATIENTS_CHARTS = 'UPDATE_PATIENTS_CHARTS',
  CONFIRM_INTAKE_CALL_SHEET_IS_COMPLETE = 'CONFIRM_INTAKE_CALL_SHEET_IS_COMPLETE',
  REQUEST_MISSING_INFORMATION_AND_UPDATE_INTAKE_CALL_SHEET = 'REQUEST_MISSING_INFORMATION_AND_UPDATE_INTAKE_CALL_SHEET',
  ENTER_PATIENT_INFORMATION_INTO_PMS = 'ENTER_PATIENT_INFORMATION_INTO_PMS',
  ENTER_CLINICAL_INFORMATION_INTO_PMS = 'ENTER_CLINICAL_INFORMATION_INTO_PMS',
  ENTER_SCHEDULED_APPOINTMENT_INTO_PMS = 'ENTER_SCHEDULED_APPOINTMENT_INTO_PMS',
  FORWARD_INTAKE_CALL_SHEET = 'FORWARD_INTAKE_CALL_SHEET',
  CONFIRM_APPOINTMENT = 'CONFIRM_APPOINTMENT',
  SEND_GENERIC_APPOINTMENT_REMINDER_TEXT_MESSAGE = 'SEND_GENERIC_APPOINTMENT_REMINDER_TEXT_MESSAGE',
  ADD_CHART_NOTES = 'ADD_CHART_NOTES',
  NOTIFY_REFERRING_DENTAL_OFFICE_RESCHEDULED = 'NOTIFY_REFERRING_DENTAL_OFFICE_RESCHEDULED',
  NOTIFY_PATIENT_OF_CANCELLED_APPOINTMENT = 'NOTIFY_PATIENT_OF_CANCELLED_APPOINTMENT',
  NOTIFY_REFERRING_DENTAL_OFFICE_CANCELLED = 'NOTIFY_REFERRING_DENTAL_OFFICE_CANCELLED',
  SEND_GENERIC_CANCELLATION_TEXT_MESSAGE = 'SEND_GENERIC_CANCELLATION_TEXT_MESSAGE',
  ADD_CHART_NOTES_WITH_CHECKLIST = 'ADD_CHART_NOTES_WITH_CHECKLIST',
  DETERMINE_IF_CAN_ADJUST_SCHEDULE = 'DETERMINE_IF_CAN_ADJUST_SCHEDULE',
  PROPOSE_APPOINTMENT_CHANGE_WITH_PATIENT = 'PROPOSE_APPOINTMENT_CHANGE_WITH_PATIENT',
  ENTER_NEW_APPOINTMENT_DATE_AND_TIME = 'ENTER_NEW_APPOINTMENT_DATE_AND_TIME',
  COMPLETE_SURVEY = 'COMPLETE_SURVEY'
}

export enum EmployeeSatisfactionStatus {
  VERY_DISSATISFIED = 'VERY_DISSATISFIED',
  DISSATISFIED = 'DISSATISFIED',
  SLIGHTLY_DISSATISFIED = 'SLIGHTLY_DISSATISFIED',
  NEUTRAL = 'NEUTRAL',
  SLIGHTLY_SATISFIED = 'SLIGHTLY_SATISFIED',
  SATISFIED = 'SATISFIED',
  VERY_SATISFIED = 'VERY_SATISFIED',
}

export const valueToEmployeeSatisfactionStatus = {
  '0': EmployeeSatisfactionStatus.VERY_DISSATISFIED,
  '1': EmployeeSatisfactionStatus.DISSATISFIED,
  '2': EmployeeSatisfactionStatus.SLIGHTLY_DISSATISFIED,
  '3': EmployeeSatisfactionStatus.NEUTRAL,
  '4': EmployeeSatisfactionStatus.SLIGHTLY_SATISFIED,
  '5': EmployeeSatisfactionStatus.SATISFIED,
  '6': EmployeeSatisfactionStatus.VERY_SATISFIED
};

export enum TaskField {
  MULTI_SELECT = 'MULTI_SELECT',
  SELECT = 'SELECT',
  TEXT = 'TEXT',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  OPERATORY_SELECT = 'OPERATORY_SELECT',
  TREATMENT_SELECT = 'TREATMENT_SELECT',
  SENTIMENT_SLIDER = 'SENTIMENT_SLIDER',
  EMPLOYEE_STUCKS_CHECKLIST = 'EMPLOYEE_STUCKS_CHECKLIST'
}

export enum TaskFieldRequiredState {
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  REQUIRED_BY_CONDITION = 'REQUIRED_BY_CONDITION'
}

export enum DatePickerValidation {
  FUTURE_DATE = 'FUTURE_DATE',
  FUTURE_OR_CURRENT_DATE = 'FUTURE_OR_CURRENT_DATE'
}

export enum DatePickerType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export enum TaskGridIconsTitles {
  TO_ELEMENT = 'Show Current Task',
  ZOOM_OUT = 'Zoom Out',
  ZOOM_IN = 'Zoom In'
}

export enum ZoomGridOptions {
  ZOOM_STEP = 0.3,
  MIN_SCALE = 0.7,
  MAX_SCALE = 2,
  INITIAL_SCALE = 1
}

export enum ProcessDiagramIds {
  START = 'processStart',
  END = 'processEnd'
}

export enum AdditionalDataType {
  CODE = 'CODE',
  CODES = 'CODES',
  PLAIN_TEXT = 'PLAIN_TEXT'
}
